export const API_URL_PAYMENT = "/payment";
export const API_URL_PAYMENT_REFILL = "/payment/refill";
export const API_URL_PAYMENT_REFILL_CONFIRM = "/payment/refill/confirm";
